import { LexRuntimeV2Client, RecognizeTextCommand } from "@aws-sdk/client-lex-runtime-v2";
import { PollyClient, SynthesizeSpeechCommand } from "@aws-sdk/client-polly";
import { v4 as uuidV4 } from "uuid";

const REGION = process.env.REACT_APP_AWS_REGION;
const BOT_ID = process.env.REACT_APP_AWS_BOT_ID;
const BOT_ALIAS_ID = process.env.REACT_APP_AWS_BOT_ALIAS_ID;
const LOCALE_ID = process.env.REACT_APP_AWS_LOCALE_ID;

const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;

const client = new LexRuntimeV2Client({
    region: REGION,
    credentials: {
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
    },
});

const pollyClient = new PollyClient({
    region: REGION,
    credentials: {
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
    }
});

const RecognizeTextAsync = async (userInput, sessionId = uuidV4()) => {
    try {
        const command = new RecognizeTextCommand({
            botId: BOT_ID,
            botAliasId: BOT_ALIAS_ID,
            localeId: LOCALE_ID,
            sessionId,
            text: userInput,
        });
        const response = await client.send(command);
        if (response.messages && response.messages.length > 0) {
            return {
                success: true,
                data: response,
            };
        } else {
            return {
                success: false,
                error: "No messages returned from Lex.",
                data: response,
            };
        }
    } catch (error) {
        return {
            success: false,
            error: error.message || JSON.stringify(error),
        };
    }
};

const SynthesizeSpeechAsync = async (text) => {
    try {
        const command = new SynthesizeSpeechCommand({
            Text: text,
            OutputFormat: "mp3",
            VoiceId: "Joanna",
            Engine: "standard"
        });
        const response = await pollyClient.send(command);
        if (response) {
            const audioBlob = await new Response(response.AudioStream).blob();
            const url = URL.createObjectURL(audioBlob);
            return { success: true, url: url };
        }
    }
    catch (error) {
        return { success: false};
    }
}
export { RecognizeTextAsync, SynthesizeSpeechAsync };
